import type { Choice, IntroChoiceUrlEnum, Keyword, Language, LinkValues, PageContent } from './selvtestSlice';
import type { RootState } from './store';

export const selectPage = (state: RootState, url: string): PageContent | undefined => state.pages?.find(p => p.urlPath === url);

export const selectTemaValg = (state: RootState, url: string): PageContent | undefined => state.pages?.find(p => p.urlPath === url);

export const selectSpecificPage = (state: RootState, url: string | null): PageContent | undefined =>
  state.pages?.find(p => p.urlPath === url);
export const selectSessionId = (state: RootState): string | undefined => state.sessionId;
export const selectCurrentPage = (state: RootState): string | null => state.currentPage;
export const selectChosenAnswers = (state: RootState): Choice[] | null => state.chosenAnswers;
export const selectPoppedUrls = (state: RootState): string[] | null => state.poppedUrls;
export const selectIntroChoiceUrl = (state: RootState): IntroChoiceUrlEnum | null => state.introChoiceUrl;
export const selectLane = (state: RootState): string | undefined => state.lane;
export const selectLaneData = (state: RootState): PageContent | undefined => state.pages?.find(p => p.urlPath === state.lane);
export const selectPageByUrlPath = (state: RootState, urlPath: string | null): PageContent | undefined =>
  state.pages?.find(p => p.urlPath === urlPath);
export const selectAnsweredIntro = (state: RootState): boolean => state.answeredIntro;
export const selectExternalQuestionnaire = (state: RootState): LinkValues | undefined =>
  state.externalLinks?.find(l => l.linkName === 'externalQuestionnaire')?.linkValues;
export const selectExternalTilgjengelighetserklaering = (state: RootState): LinkValues | undefined =>
  state.externalLinks?.find(l => l.linkName === 'externalTilgjengelighetserklaering')?.linkValues;
export const selectKeywords = (state: RootState): Keyword[] | null => state.keywords;
export const selectLanguages = (state: RootState): Language[] | null => state.languages;
